import React, { Component } from "react";
import { connect } from "react-redux";
import { Router, Route, Link } from "react-router-dom";


import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.min.js'
import "./App.css";

//notifications
import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'

// import BoardModerator from "./components/board-moderator.component";
// import BoardAdmin from "./components/board-admin.component";
import Home from "./components/Home.jsx"
import Radio from "./components/Radio.jsx"
import Player from "./components/radio/Player.jsx"
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { ReactSVG } from 'react-svg'

//spotify

import { logout } from "./actions/auth";
import { clearMessage } from "./actions/message";

import { history } from './helpers/history';

import { store } from 'react-notifications-component';

class App extends Component {
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);

    this.state = {
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined,
      snow: 0,
      terraincolor: '#14800a',
      fieldcolor: '#f5be18',
      treecolor: '#076931',
      rain: 0,
      state: 0,
      numberclouds: 0,
      roadcolor: '#544c3e',
      town:'berlin',
      bears: 0,
      hintPlayerUpdate: 0,
      playing: false,
      radiocounter: 0,
      radioUrl: 'https://nebcoradio.com:1010/KBEN',
      radioName: 'Radio Caroline UK',
      modified: false,
      tweet: 'JulienClerc_Off',
      modalShow: false,
      preloader: "block",
      data: [['https://nebcoradio.com:1010/KBEN','The Adventure The Big Horns Genuine Country ', 'KBN', '1'],['https://musicbird.leanstream.co/CFCYFM-MP3-2','CFCY-FM Charlottetown, PE, Canada, The Islands Country', 'CFY', '2'],['https://ice07.fluidstream.net/KKItalia.mp3','Radio Kiss Italia Napoli, Radio ufficiale SSC Napoli', 'KKS', '3'],['https://icecast2.play.cz/country64.mp3','Klidné rádio do neklidné doby', 'PRA', '4']]
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleButtonSnow = this.handleButtonSnow.bind(this)
    this.handleButtonRain = this.handleButtonRain.bind(this)
    this.updatePlayer = this.updatePlayer.bind(this)
    this.setPreloader = this.setPreloader.bind(this)
    this.handleCallback = this.handleCallback.bind(this)


    history.listen((location) => {
      props.dispatch(clearMessage()); // clear message when changing location
    });
  }

  handleButtonSnow(){
    if ( this.state.snow == 0 ){
      this.setState({
        snow: 100,
        terraincolor: '#ffffff',
        fieldcolor: '#dedede',
        treecolor: '#ffffff',
        state: 1,
        numberclouds: 50,
        cloudscolor: '#ffffff',
        roadcolor: '#ffffff'
      })
    }
    else
    {
      this.setState({
        snow: 0,
        terraincolor: '#516e20',
        fieldcolor: '#fcc305',
        treecolor: '#006335',
        numberclouds: 0,
        cloudscolor: '#ffffff',
        roadcolor: '#544c3e'
      })
    }
  }
  handleButtonRain(){
    if ( this.state.rain == 0 ){
      this.setState({
        rain: 100,
        terraincolor: '#095c02',
        fieldcolor: '#542704',
        treecolor: '#024712',
        numberclouds: 50,
        cloudcolors: '#ffffff'
      })
    }
    else
    {
      this.setState({
        rain: 0,
        terraincolor: '#516e20',
        fieldcolor: '#fcc305',
        treecolor: '#006335',
        numberclouds: 0,
        cloudscolor: '#ffffff'
      })
    }
  }

  /*getRadioState(){


    this.setState({
      playing: statez.bears
    });
    return null
  }*/

  updatePlayer(){
    let radioUrls = []
    let radioNames = []
    this.state.data.forEach(function (arrayItem) {
      let url = arrayItem[0]
      radioUrls.push(url)
    }); 
    this.state.data.forEach(function (arrayItem) {
      let name = arrayItem[1]
      radioNames.push(name)
    }); 
    
    this.setState({
      hintPlayerUpdate: this.state.hintPlayerUpdate + 5,
      radiocounter: this.state.radiocounter + 1
    })

    if ((this.state.radiocounter/2) < radioUrls.length){
      if (this.state.playing == false){
        this.setState({
          modified: false,
          playing: true,
          radioUrl: radioUrls[this.state.radiocounter/2],
          radioName: radioNames[this.state.radiocounter/2],
        })
      }
      else
      {
        this.setState({
          modified: true,
          playing: false,
        })
      }
    }
    else if (this.state.radiocounter == (radioUrls.length)*2)
    {
      this.setState({
        modified: false,
        playing: true,
        radiocounter: 1,
        radioUrl: radioUrls[0],
        radioName: radioNames[0]
      })
    }
    else{
      this.setState({
        modified: false,
        playing: true,
        radiocounter: 1,
        radioUrl: radioUrls[0]
      })
    }
  }

  logOut() {
    this.props.dispatch(logout());
  }

  handleSubmit(event){
    event.preventDefault()
    store.addNotification({
      title: "Loading",
      message: "Wait to know...",
      type: "success",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 3000,
        onScreen: true
      }
    });
    this.setState({ 
      // Computed property names 
      // keys of the objects are computed dynamically 
      town : this.state.textlocation,
    })

    //var contextTown = ThreeContext;
    //console.log()

    setTimeout(function(){
      this.setState({ 
        // Computed property names 
        // keys of the objects are computed dynamically 
        preloader: "none"
      });
    }.bind(this),3000);
  }

  handleChange(event){
    this.setState({ 
      // Computed property names 
      // keys of the objects are computed dynamically 
      [event.target.name] : event.target.value
    })
  }

  handleCallback = (childData) =>{
    this.setState({data: childData})
  }

  setPreloader() {
    console.log("TOOOOOOOTOOOOOOOOOO "+window.location.pathname)
    this.setState({ 
      // Computed property names 
      // keys of the objects are computed dynamically 
      preloader : "true"
    })
  };

  /*  <Radio
                      updatePlayer={this.updatePlayer}
                      parentCallback={this.handleCallback}
                />  */

  render() {
    return (
        <Router history={history}>
          <div>
            <div className="preloader" style={{display: this.state.preloader}}>
            <form onSubmit={this.handleSubmit}>
              <ReactSVG src="littlemeteo.svg" className="littlemeteo-logo"/>
              <h3 className="preloader-title">Set a location</h3>
              <p className="preloader-description">And get a real-time meteo, visually displayed on a tiny little american redneck farm with three.js (3D). Experimental project. Free to use and look at.</p>
              <div className="preloader-input-container">
                <input className="preloader-input" type="text" value={this.state.textlocation} name="textlocation" onChange={this.handleChange}></input>
                <button className="preloader-button">go</button>

              <p className="preloader-description-disclaimer">(Disclaimer : That's not very light, if you're on Windows 2000 and got the Internet Explorer version that goes with it... it could melt your laptop. 60 API calls an hour on openweathermap so it might not work if too many people search for too many towns.)</p>
              <p><a href="https://vincentlhoste.fr" className="vllink">Site by Vincent Lhoste.</a></p>
              </div>
            </form>
            </div>
            <ReactNotification />
            <Popup trigger={<button className="button-radio"> Radio controls </button>} modal>
              <span> 
                <Radio
                      updatePlayer={this.updatePlayer}
                      parentCallback={this.handleCallback}
                />  
              </span>
            </Popup>
            <Player hintPlayerUpdate = { this.state.hintPlayerUpdate } playing = { this.state.playing } radioUrl={ this.state.radioUrl } radioName={ this.state.radioName } radiocounter={this.state.radiocounter}/>
            <div className="">
              <Route
                  exact path='/radio'
                  render={props => <Radio
                      updatePlayer={this.updatePlayer}
                      parentCallback={this.handleCallback}
                  />}/>
              <Route
                  exact path='/'
                  render={props => 
                    <Home
                        snow={this.state.snow}
                        rain={this.state.rain}
                        terraincolor={this.state.terraincolor}
                        state={this.state.state}
                        fieldcolor={this.state.fieldcolor}
                        treecolor={this.state.treecolor}
                        numberclouds={this.state.numberclouds}
                        cloudscolor={this.state.cloudcolors}
                        location={this.state.location}
                        roadcolor={this.state.roadcolor}
                        town={this.state.town}
                        updatePlayer={this.updatePlayer}
                        setPreloader={this.state.preloader}
                    />
                  }/>
            </div>
          </div>
        </Router>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.auth;
  return {
    user,
  };
}

export default connect(mapStateToProps)(App);


/*Optional snow and rain button
<div className='coucou'>
              <button onClick={this.handleButtonSnow}>Snow</button>
              <button onClick={this.handleButtonRain}>Rain</button>
            </div>*/